if ($('.type-category').length) {
    $(document).ready(categoryEdit);
    document.addEventListener('ShoptetDOMPageContentLoaded', categoryEdit);
    document.addEventListener('ShoptetPageSortingChanged', categoryEdit);
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', categoryEdit);
}


function categoryEdit() {
    if ($(".subcategories").length) {
        $(".subcategories li img").each(function () {
            $(this).attr(
                "data-src",
                $(this).attr("data-src").replace("/thumb/", "/orig/"),
            );
        });
    }
    $('.loadMore button').length ? $('.loadMore button').text('Načíst další produkty') : null;
    if(!$('#category-header .orderBy').length){
        $('#category-header').append('<span class="orderBy">Řadit dle</span>')
    }   


    $(document).on('click', '#category-header .orderBy', function (e) {

        $('.listSorting ').toggleClass('visible');
    });

    $("a.btn.btn-default.unveil-button").text("Filtrovat");

}

